<div class="rs-navigation-buttons">
  <button mat-raised-button color="primary" class="app__button" (click)="reactOnDashboardClick()">{{'buttons.back-to-dashboard' | translate}}</button>
  <button [disabled]="isNextDisabled" *ngIf="!dashboardOnly" mat-raised-button color="primary" class="app__button" (click)="reactOnClickNext()">{{'buttons.next' | translate}}</button>
</div>
